const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLectureManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M72.15,68.11V17.6c0-5.58,4.52-10.1,10.1-10.1H494.4c5.58,0,10.1,4.52,10.1,10.1v313.15c0,5.58-4.52,10.1-10.1,10.1H223.66"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 72.15,
    y1: 166.06,
    x2: 72.15,
    y2: 103.11
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 72.15,
    y1: 37.805,
    x2: 504.5,
    y2: 37.805
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M221.978,285.402l14.286-14.286c7.89-7.89,20.682-7.89,28.572,0l0,0c7.89,7.89,7.89,20.682,0,28.572l-14.286,14.286"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M7.5,504.5V381.26c0-22.32,18.09-40.41,40.41-40.41h24.24"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.82,
    y1: 472.51,
    x2: 138.82,
    y2: 504.5
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 104.48,340.85 166.53,340.85 221.98,285.4 250.55,313.97 183.27,381.26 138.82,405.66 138.82,437.51 \t"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M104.476,321.638v19.21c0,8.926-7.236,16.163-16.163,16.163h0c-8.926,0-16.163-7.236-16.163-16.163v-19.21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M45.886,247.914v34.346c0,23.432,18.995,42.427,42.427,42.427h0c23.432,0,42.427-18.995,42.427-42.427v-34.346"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M146.902,247.914V223.67c0-32.358-26.231-58.589-58.589-58.589h0c-32.358,0-58.589,26.231-58.589,58.589v24.244"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M45.886,247.914L45.886,247.914c20.947,0,33.461-10.102,33.461-10.102v10.102c23.133-2.631,31.855-20.203,31.855-20.203 s3.996,15.427,19.537,20.203"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M140.841,280.239H130.74v-32.325h10.102c8.926,0,16.163,7.236,16.163,16.163v0C157.004,273.003,149.768,280.239,140.841,280.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M35.785,280.239h10.102v-32.325H35.785c-8.926,0-16.163,7.236-16.163,16.163v0C19.622,273.003,26.858,280.239,35.785,280.239z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 37.805,
    y1: 504.5,
    x2: 37.805,
    y2: 411.012
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 291.036,
    cy: 383.528,
    r: 42.693
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M362.191,504.5v-42.702c0-19.656-15.939-35.577-35.577-35.577H255.46c-19.649,0-35.577,15.928-35.577,35.577V504.5"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 433.344,
    cy: 383.528,
    r: 42.693
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M504.5,504.5v-42.702c0-19.656-15.939-35.577-35.577-35.577h-71.154c-19.649,0-35.577,15.928-35.577,35.577V504.5"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 443.89,
    y1: 229.736,
    x2: 403.607,
    y2: 229.736
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 371.281,
    y1: 229.736,
    x2: 351.078,
    y2: 229.736
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 389.341,
    y1: 260.04,
    x2: 351.078,
    y2: 260.04
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M414.92,199.43h43.11c8.93,0,16.17,7.24,16.17,16.16v58.59c0,8.93-7.24,16.17-16.17,16.17h-10.1v13.06c0,3.94-3.2,7.14-7.14,7.14 c-1.9,0-3.71-0.75-5.05-2.09l-18.11-18.11h-80.69c-8.93,0-16.17-7.24-16.17-16.17v-58.59c0-8.92,7.24-16.16,16.17-16.16h42.98"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.236,
    y1: 98.414,
    x2: 244.444,
    y2: 98.414
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 212.118,
    y1: 98.414,
    x2: 191.915,
    y2: 98.414
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 323.236,
    y1: 128.719,
    x2: 191.915,
    y2: 128.719
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000B58",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M337.379,68.11H177.773c-8.926,0-16.163,7.236-16.163,16.163v58.567c0,8.926,7.236,16.163,16.163,16.163h10.102v13.06 c0,3.945,3.198,7.143,7.143,7.143h0c1.894,0,3.711-0.753,5.051-2.092l18.111-18.111h119.199c8.926,0,16.163-7.236,16.163-16.163 V84.272C353.541,75.346,346.305,68.11,337.379,68.11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLectureManagement);
export default __webpack_public_path__ + "static/media/lecture-management.1a8c4546cfd92348c232cb4bbaa52cab.svg";
export { ForwardRef as ReactComponent };